import React from "react";

function Words({ children, selection = true }) {
  return children
    .toString()
    .split(" ")
    .map((item, index) => {
      return (
        <span
          key={index}
          data-observable
          data-initial-styles="transform translate-y-[30px] opacity-0 scale-90"
          className={`inline-flex ${
            selection && !index ? "text-white/50" : ""
          }`}
        >
          {item}
          <> </>
        </span>
      );
    });
}

export default React.memo(Words);
